import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { take } from 'rxjs/operators';
import { SettingsService } from '@core/services/settings.service';
import { inject } from '@angular/core';

export const environmentGuard: CanActivateFn = () => {
    const settingsService: SettingsService = inject(SettingsService);
    const router: Router = inject(Router);
    if (environment.production) {
        settingsService.settings$
            .pipe(take(1))
            .subscribe(
                ({ pageReferences }) =>
                    pageReferences?.notFoundErrorPage?.url && router.navigateByUrl(pageReferences.notFoundErrorPage.url)
            );
        return false;
    }
    return true;
};
